(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.section-pd-announcement-bar');


      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        if (this.announcementBar) {
          this.announcementBar.classList.add('scrolled-past-announcement-bar');
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcementBar) {
          this.announcementBar.classList.remove('scrolled-past-announcement-bar');
        }

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.announcementBar) {
          this.announcementBar.classList.remove('scrolled-past-announcement-bar');
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();

      window.dispatchEvent(new CustomEvent('header:hide', { detail: { top: 0 } }));
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      const top = this.getAnnouncementBarHeight() + this.getHeaderHeight() - 1;

      window.dispatchEvent(new CustomEvent('header:reveal', { detail: { top } }));
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      window.dispatchEvent(new CustomEvent('header:reset', { detail: { top: 0 } }));
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }

    getAnnouncementBarHeight() {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height');
      const height = parseFloat(value);
      return Number.isNaN(height) ? 0 : height;
    }

    getHeaderHeight() {
      return this.header.offsetHeight;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-announcement-bar"] && !Shopify.designMode) return;
  try {
    

  class StickyAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionWrapper = this.closest('.section-pd-announcement-bar') || this;
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.isSticky = this.isStickyEnabled();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.updateAnnouncementBarHeight.bind(this);
      this.onHeaderHideHandler = this.onHeaderHide.bind(this);
      this.onHeaderRevealHandler = this.onHeaderReveal.bind(this);
      this.onHeaderResetHandler = this.onHeaderReset.bind(this);

      this.createObserver();
      this.updateAnnouncementBarHeight();

      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('header:hide', this.onHeaderHideHandler);
      window.addEventListener('header:reveal', this.onHeaderRevealHandler);
      window.addEventListener('header:reset', this.onHeaderResetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('header:hide', this.onHeaderHideHandler);
      window.removeEventListener('header:reveal', this.onHeaderRevealHandler);
      window.removeEventListener('header:reset', this.onHeaderResetHandler);
    }

    isStickyEnabled() {
      return this.hasAttribute('sticky-enabled') || Boolean(this.querySelector('.pd-announcement-bar--sticky'));
    }

    createObserver() {
      if (!this.header) return;

      const observer = new IntersectionObserver((entries, observed) => {
        this.headerBounds = entries[0].intersectionRect;
        observed.disconnect();
      });

      observer.observe(this.header);
    }

    updateAnnouncementBarHeight() {
      const stickyBar = this.querySelector('.pd-announcement-bar');
      document.documentElement.style.setProperty(
          '--announcement-bar-height',
          `${stickyBar.offsetHeight}px`
        );
    }

    onScroll() {
      if (!this.isSticky) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.headerBounds.bottom) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.sectionWrapper.classList.add('scrolled-past-announcement-bar');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.sectionWrapper.classList.remove('scrolled-past-announcement-bar');
      } else if (scrollTop <= this.headerBounds.top) {
        this.sectionWrapper.classList.remove('scrolled-past-announcement-bar');
      }

      this.currentScrollTop = scrollTop;
    }

    onHeaderHide(event) {
      if (!this.isStickyEnabled()) return;
      this.sectionWrapper.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    onHeaderReveal(event) {
      if (!this.isStickyEnabled()) return;
      this.sectionWrapper.classList.add('shopify-section-header-sticky', 'animate');
      this.sectionWrapper.classList.remove('shopify-section-header-hidden');
    }

    onHeaderReset(event) {
      if (!this.isStickyEnabled()) return;
      this.sectionWrapper.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-promotion-timer-mb"] && !Shopify.designMode) return;
  try {
    
  class StickyPromotionTimer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionWrapper = this.closest('.section-promotion-timer-mobile') || this;
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.updatePromotionTimerHeight.bind(this);
      this.onHeaderHideHandler = this.onHeaderHide.bind(this);
      this.onHeaderRevealHandler = this.onHeaderReveal.bind(this);
      this.onHeaderResetHandler = this.onHeaderReset.bind(this);

      this.createObserver();
      this.updatePromotionTimerHeight();

      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('header:hide', this.onHeaderHideHandler);
      window.addEventListener('header:reveal', this.onHeaderRevealHandler);
      window.addEventListener('header:reset', this.onHeaderResetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('header:hide', this.onHeaderHideHandler);
      window.removeEventListener('header:reveal', this.onHeaderRevealHandler);
      window.removeEventListener('header:reset', this.onHeaderResetHandler);
    }

    isStickyEnabled() {
      return Boolean(this.querySelector('.promotion-timer-mobile-wrapper--sticky'));
    }

    createObserver() {
      if (!this.header) return;

      const observer = new IntersectionObserver((entries, observed) => {
        this.headerBounds = entries[0].intersectionRect;
        observed.disconnect();
      });

      observer.observe(this.header);
    }

    updatePromotionTimerHeight() {
      const stickyBar = this.querySelector('.promotion-timer-mobile-wrapper');
      if (!stickyBar) return;
      document.documentElement.style.setProperty(
        '--promotion-timer-mobile-height',
        `${stickyBar.offsetHeight}px`
      );
    }

    onScroll() {
      if (!this.isStickyEnabled()) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.headerBounds.bottom) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.sectionWrapper.classList.add('scrolled-past-promotion-timer');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.sectionWrapper.classList.remove('scrolled-past-promotion-timer');
      } else if (scrollTop <= this.headerBounds.top) {
        this.sectionWrapper.classList.remove('scrolled-past-promotion-timer');
      }

      this.currentScrollTop = scrollTop;
    }

    onHeaderHide(event) {
      if (!this.sectionWrapper) return;

      this.sectionWrapper.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    onHeaderReveal(event) {
      if (!this.sectionWrapper) return;

      this.sectionWrapper.classList.add('shopify-section-header-sticky', 'animate');
      this.sectionWrapper.classList.remove('shopify-section-header-hidden');
    }

    onHeaderReset(event) {
      if (!this.sectionWrapper) return;

      this.sectionWrapper.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  customElements.define('sticky-promotion-timer', StickyPromotionTimer);

  } catch(e) { console.error(e); }
})();
})();
